<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-spinner v-if="!ready"/>
        <b-form @submit.prevent="onSubmit">
          <b-card header="User Information" v-show="ready">
            <Loading :active="busy" :is-full-page="false">
              <slot>
                <hm-spinner/>
              </slot>
            </Loading>
            <hm-alert/>
            <b-form-group label="First Name">
              <b-form-input
                name="firstName"
                type="text"
                class="form-control"
                placeholder="First Name"
                autocomplete="given-name"
                v-model="user.firstName"
                v-validate="'required'"
                :disabled="busy"
                :class="{ 'is-invalid': errors.has('firstName') && submitted }"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Last Name">
              <b-form-input
                name="lastName"
                type="text"
                class="form-control"
                placeholder="Last Name"
                autocomplete="family-name"
                v-model="user.lastName"
                v-validate="'required'"
                :disabled="busy"
                :class="{ 'is-invalid': errors.has('lastName') && submitted }"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Options">
              <b-form-checkbox v-model="tours">Show dashboard page tour</b-form-checkbox>
            </b-form-group>
            <div slot="footer">
              <b-row>
                <b-col class="text-right">
                  <b-button type="submit" variant="primary" class="px-4" :disabled="busy">Save</b-button>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-card header="License Information" v-show="ready">
          <Loading :active="busy" :is-full-page="false">
            <slot>
              <hm-spinner/>
            </slot>
          </Loading>
          <div>Subscription expires: {{licenseDaysRemaining}} days</div>
          <div slot="footer" v-if="licenseDaysRemaining < 30">
            <b-row>
              <b-col class="text-right">
                <b-button type="submit" variant="secondary" :disabled="busy" to="/renew">Renew Now</b-button>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { authService } from '@/services';

export default {
  name: 'Profile',
  data() {
    return {
      user: {
        firstName: '',
        lastName: ''
      },
      tours: false,
      ready: false,
      busy: false,
      submitted: false
    }
  },
  computed: {
    ...mapState('progress', { progressFlags: 'flags' }),
    ...mapState('user', {
      licenseDaysRemaining(state) {
        return state.license && state.license.remaining ? state.license.remaining : 365;
      }
    })
  },
  methods: {
    ...mapActions({
      alertClear: 'alert/clear',
      alertSuccess: 'alert/success',
      alertError: 'alert/error',
      alertException: 'alert/exception',
      setProgress: 'progress/setFlag',
    }),
    onSubmit() {
      this.busy = true;
      this.submitted = true;
      this.alertClear();

      this.$validator.validate()
        .then(valid => {
          if (valid) {
            return authService.setUser(this.user)
              .then(resp => {
                this.setProgress({ flag: 'TourWelcome', value: !this.tours });
                this.alertSuccess('Profile changes saved successfully!');
              })
              .catch(err => {
                this.alertException({ err, message: 'Error saving profile.' });
              });
          } else {
            this.alertError('Please complete profile form fields and submit again.');
          }
        })
        .finally(() => {
          this.busy = false;
        });
    }
  },
  created() {
    this.ready = false;
    this.tours = !this.progressFlags['TourWelcome'];

    authService.getUser()
      .then(data => {
        this.user = data;
        return this.$store.dispatch('user/fetchLicense');
      })
      .catch(err => {
        this.alertException({ err, message: 'Error loading user profile.' });
      })
      .finally(() => {
        this.ready = true;
      });
  }
}
</script>